import { AlertTriangle, TrendingDown, Clock, Zap } from "lucide-react";
import { useI18n } from "../../i18n";

const FAILS = [
  { icon: AlertTriangle, pct: "76%", t: "fail1_title", d: "fail1_desc" },
  { icon: TrendingDown, pct: "62%", t: "fail2_title", d: "fail2_desc" },
  { icon: Clock, pct: "54%", t: "fail3_title", d: "fail3_desc" },
  { icon: Zap, pct: "49%", t: "fail4_title", d: "fail4_desc" },
];

export default function Problem() {
  const { t } = useI18n();
  return (
    <section className="relative py-16 sm:py-20 lg:py-28 border-y border-[#23232a]/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="chip" style={{ color: "#ff9c9c", borderColor: "rgba(255,92,92,.35)" }}>{t("problem_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            <span className="text-[#ff9c9c]">{t("problem_h1_a")}</span> {t("problem_h1_b")}
          </h2>
          <p className="text-[color:var(--ink-dim)] mt-4 leading-relaxed text-[14px] sm:text-[15px]">{t("problem_sub")}</p>
        </div>

        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {FAILS.map((f) => (
            <div key={f.t} className="panel p-5 sm:p-6 relative">
              <div className="flex items-start justify-between">
                <div className="w-10 h-10 rounded-xl grid place-items-center border border-[#23232a] bg-[rgba(255,92,92,.04)]">
                  <f.icon className="w-4.5 h-4.5 text-[#ff9c9c]" />
                </div>
                <div className="font-display font-black text-2xl sm:text-3xl text-[#ff9c9c]/80">{f.pct}</div>
              </div>
              <div className="font-display font-bold text-base sm:text-[17px] mt-4">{t(f.t)}</div>
              <p className="text-[13px] sm:text-[13.5px] text-[color:var(--ink-dim)] mt-2 leading-relaxed">{t(f.d)}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-xs text-[color:var(--ink-mute)] italic">{t("problem_disclaimer")}</div>
      </div>
    </section>
  );
}
